import React from "react";
import { Pagination } from "react-bootstrap";
import { IListPagingProps, PaginationChangeType } from "../../interfaces/Components/ListPagination/IListPagingProps"

export const ListPagination = ({numberOfPages, activePage, onChange, showPrevNextMarkers, maxPageMarkersToShow, accessibilityPrefix, accessibilitySuffix} : IListPagingProps) => {

    let pageItems : Array<JSX.Element> = [];
    let start : number;
    let end :number;

    const pagePrefix = (accessibilityPrefix) ? <span className="visually-hidden">{accessibilityPrefix}</span> : null;
    const pageSuffix = (accessibilitySuffix) ? <span className="visually-hidden">{accessibilitySuffix}</span> : null;

    if (!maxPageMarkersToShow) {
        start = 1;
        end = numberOfPages;
    } else {
        let adjustedMaxPageMarkersToShow = maxPageMarkersToShow;
        if(adjustedMaxPageMarkersToShow % 2 === 0) { // This needs to be an odd number to give a good balance.
            adjustedMaxPageMarkersToShow += 1; 
        }

        const pagesEachSide = Math.floor(adjustedMaxPageMarkersToShow / 2);
        let endAdjustment = 0;
        let startAdjustment = 0;

        if(activePage - pagesEachSide >= 1) {
            start = activePage - pagesEachSide;
        } else {
            endAdjustment = Math.abs(activePage - (pagesEachSide + 1));
            start = 1;
        }

        if(activePage + pagesEachSide <= numberOfPages) {
            end = activePage + pagesEachSide;
        } else {
            startAdjustment = Math.abs(numberOfPages - (activePage + pagesEachSide));
            end = numberOfPages;
        }
            
        if(endAdjustment > 0 && startAdjustment === 0) {
            end += endAdjustment;
            if(end > numberOfPages) {
                end = numberOfPages;
            }
        } else if(startAdjustment > 0 && endAdjustment === 0) {
            start -= startAdjustment;
            if(start < 1) {
                start = 1;
            }
        }
    }

    if(showPrevNextMarkers) {

        pageItems.push( <Pagination.First
                            key={"First"}
                            onClick={() => onChange(PaginationChangeType.Direct, 1)}
                            disabled={activePage === 1}
                            className={activePage === 1 ? "user-select-none" : ""}
                            data-testid={"pagination-first"}
                        ></Pagination.First>);
        pageItems.push( <Pagination.Prev
                            key={"Prev"}
                            onClick={() => onChange(PaginationChangeType.Back, 1)}
                            disabled={activePage === 1}
                            className={activePage === 1 ? "user-select-none" : ""}
                            data-testid={"pagination-prev"}
                        ></Pagination.Prev>);
    }

    if(start !== 1) {
         pageItems.push(<Pagination.Ellipsis key={"lowerEllipse"} disabled={true} className="user-select-none"></Pagination.Ellipsis>);
    }

    for(let i = start; i <= end; i += 1) {
        pageItems.push( <Pagination.Item
                            key={i}
                            active = {i === activePage}
                            onClick={() => (onChange(PaginationChangeType.Direct, i))}
                        >
                            {pagePrefix} {i} {pageSuffix}
                        </Pagination.Item>);
    }

    if(end !== numberOfPages) {
        pageItems.push(<Pagination.Ellipsis key={"upperEllipse"} disabled={true} className="user-select-none"></Pagination.Ellipsis>);
    }

    if(showPrevNextMarkers) {
        pageItems.push( <Pagination.Next
            key={"Next"}
            onClick={() => onChange(PaginationChangeType.Forward, 1)}
            disabled={activePage === numberOfPages}
            className={activePage === numberOfPages ? "user-select-none" : ""}
            data-testid={"pagination-next"}
        ></Pagination.Next>);

        pageItems.push( <Pagination.Last
                            key={"Last"}
                            onClick={() => onChange(PaginationChangeType.Direct, numberOfPages)}
                            disabled={activePage === numberOfPages}
                            className={activePage === numberOfPages ? "user-select-none" : ""}
                            data-testid={"pagination-last"}
                        ></Pagination.Last>);
    }

    return  <div className="mw-100">
                <Pagination className="mb-0 ml-0 float-end">
                    {pageItems}
                </Pagination>
            </div>
}
